import { render } from "./resume.vue?vue&type=template&id=185fbe8a&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"

import "./resume.vue?vue&type=style&index=0&id=185fbe8a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185fbe8a"]])

export default __exports__